"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeTradeDataType = exports.normalizeOfferDataType = void 0;
const common_sdk_1 = require("@orca-so/common-sdk");
const _1 = require(".");
const normalizeOfferDataType = (offerData) => {
    return Object.assign(Object.assign({}, offerData), { rate: (0, _1.unScale)(offerData.rate, _1.SCALE_EXPO) });
};
exports.normalizeOfferDataType = normalizeOfferDataType;
const normalizeTradeDataType = (tradeData) => {
    return Object.assign(Object.assign({}, tradeData), { fiatAmount: common_sdk_1.DecimalUtil.fromU64(tradeData.fiatAmount, _1.SCALE_EXPO).toNumber() });
};
exports.normalizeTradeDataType = normalizeTradeDataType;
